import React, { Component } from "react";
import MultiSelect from "@kenshooui/react-multi-select";
import "@kenshooui/react-multi-select/dist/style.css";

class Multiselect extends Component {
  constructor(props) {
    super(props);
    this.handleChange = this.handleChange.bind(this);
  }
  handleChange(selectedItems) {
    switch (this.props.module) {
      case "MEETING_ATTENDANCE_REGISTER":
        const [presentInviteesGroup, apologisedInviteesGroup] =
          this.props.selectHandler(this.props.data, selectedItems);
        return this.setState({
          items: [...presentInviteesGroup, ...apologisedInviteesGroup],
          selectedItems: selectedItems,
        });
      case "MEETING_AGENDA_ADOPTION":
        this.props.selectHandler(selectedItems);
        return this.setState({ selectedItems });
      default:
        return this.setState({ selectedItems });
    }
  }

  render() {
    return (
      <MultiSelect
        items={this.props.data ?? []}
        withGrouping={this.props.withGrouping}
        selectedItems={
          Array.isArray(this.props.selected)
            ? this.props.selected.filter((x) =>
                this.props.data.some((y) => y.id === x.id)
              )
            : []
        }
        onChange={this.handleChange}
        showSelectAll={this.props.showSelectAll}
        messages={{
          noneSelectedMessage: "No selection",
          noItemsMessage: "No record...",
        }}
        responsiveHeight={this.props.height ?? "100%"}
      />
    );
  }
}

export default Multiselect;
